"use client";

import React, { createContext, useContext } from "react";
import { useKeywordProfiles } from "@/hooks/use-keyword-profiles";

type ContextValue = ReturnType<typeof useKeywordProfiles>;

const KeywordProfilesContext = createContext<ContextValue | null>(null);

export function KeywordProfilesProvider({ children }: { children: React.ReactNode }) {
    const value = useKeywordProfiles();

    return (
        <KeywordProfilesContext.Provider value={value}>
            {children}
        </KeywordProfilesContext.Provider>
    );
}

export function useKeywordProfilesContext() {
    const ctx = useContext(KeywordProfilesContext);
    if (!ctx) throw new Error("useKeywordProfilesContext must be used inside KeywordProfilesProvider");

    return ctx;
}
